import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTagsComponent } from './document-tags.component';
import { AddDocumentTagsComponent } from './add-document-tags/add-document-tags.component';
import { EditDocumentTagsComponent } from './edit-document-tags/edit-document-tags.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        DocumentTagsComponent,
        AddDocumentTagsComponent,
        EditDocumentTagsComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [DocumentTagsComponent],
})
export class DocumentTagsModule { }
